// ThankYou.jsx
import React from "react";
import { useEffect } from "react";
const ThankYou = () => {
      useEffect(() => {
    // Clear after visit
    sessionStorage.removeItem("demoSubmitted");
  }, []);
  return (
    <div
      className="demo-form-wrapper"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%)",
        padding: "24px",
      }}
    >
      <h2
        style={{
          fontSize: "2.25rem",
          fontWeight: "800",
          color: "#2d6198",
          marginBottom: "24px",
        }}
      >
        🎉 Thank You!
      </h2>
      <p
        style={{
          color: "#2d6198",
          textAlign: "center",
          maxWidth: "32rem",
          fontSize: "1.125rem",
        }}
      >
        Your demo request has been submitted successfully. We will contact you soon.
      </p>
    </div>
  );
};

export default ThankYou;
